import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Header from "./components/Header";
import Card from "./components/Card";
import ButtonMsg from "./components/ButtonMsg";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
   <App />
  </React.StrictMode>
);
